export default __webpack_public_path__ + "static/media/maximum_logo.e012e88b.png";